export const getOnlyNumbers = (str = '') => str.replace(/\D/g, '');
